import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import Qualification from './Qualification';
import withLoader from 'components/Shared/withLoader';
import { invalidateReclamationQualifications } from 'store/reclamation/detailsActions';
import { fetchReclamationQualificationsIfNeeded } from 'store/reclamation/detailsActions';

import { addNotification } from 'store/common/commonActions';

const QualificationWithLoader = withLoader(Qualification);

class QualificationContainer extends React.Component {
    
    componentDidMount() {
        this.props.fetchReclamationQualificationsIfNeeded(this.props.reclamationId);
    }

    componentDidUpdate(prevProps) {
        if (prevProps.reclamationId !== this.props.reclamationId) {
            this.props.invalidateReclamationQualifications();
            this.props.fetchReclamationQualificationsIfNeeded(this.props.reclamationId);
        }
    }

    render() {
        return (<QualificationWithLoader
            isLoading={this.props.isLoading}
            addNotification={this.props.addNotification}
            qualifications={this.props.qualifications}
            reclamationId={this.props.reclamationId}
            numeroPiece={this.props.reclamation.piece?.numeroPiece}
        />);
    }
}

QualificationContainer.propTypes = {
    reclamationId: PropTypes.number.isRequired
};

const mapStateToProps = state => ({
    isLoading: state.reclamation.details.isQualificationsLoading,
    qualifications: state.reclamation.details.qualifications
});

const mapDispatchToProps = dispatch => ({
    invalidateReclamationQualifications: () => dispatch(invalidateReclamationQualifications()),
    fetchReclamationQualificationsIfNeeded: id => dispatch(fetchReclamationQualificationsIfNeeded(id)),
    addNotification: (message, importance, closable, url) => dispatch(addNotification(message, importance, closable, url))
});

export default connect(mapStateToProps, mapDispatchToProps)(QualificationContainer);